import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface NavigationV2StateProps {
    readonly isGoingBack: boolean;
    readonly initialHistoryStackLength: number;
    readonly currentHistoryStackLength: number;
}

export class NavigationV2State implements NavigationV2StateProps {
    isGoingBack = false;
    initialHistoryStackLength = 0;
    currentHistoryStackLength = 0;
}

export default makeReducer<NavigationV2State>(
    [
        match(Actions.isGoingBack, (state, action) => {
            return {
                ...state,
                isGoingBack: action.payload.isGoingBack,
            };
        }),

        match(Actions.setInitialHistoryStackLength, (state, action) => {
            return {
                ...state,
                initialHistoryStackLength: action.payload.length,
            };
        }),

        match(Actions.setCurrentHistoryStackLength, (state, action) => {
            return {
                ...state,
                currentHistoryStackLength: action.payload.length,
            };
        }),
    ],
    new NavigationV2State(),
);
